import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientsPage } from './patients';
import { TranslateModule } from '@ngx-translate/core'; // Required for translation.
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  declarations: [
    PatientsPage
  ],
  imports: [
    IonicPageModule.forChild(PatientsPage),
    TranslateModule.forChild(), // Required for translation.
    AgGridModule.withComponents([])
  ],
})
export class PatientsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.module.ts